export default __webpack_public_path__ + "static/media/10year.339c30a4.svg";